import React from 'react';
import { sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { handle400Statuses } from '@services/api';

export const AgentSelect = (props) => {
  const { onChange, value } = props;

  const [agents, setAgents] = React.useState(null);

  const handleChange = (e) => {
    const {
      target: { value },
    } = e;
    onChange(value);
  };

  React.useEffect(() => {
    const getAllAgents = async () => {
      const URL = `v1/genai_agent_script_definitions`;
      const { status, data } = await sendApiRequest('get', URL);
      logNetRequest(status, data);
      handle400Statuses(status);
      if (status === 200) {
        setAgents(data.sort((a, b) => a.script_name.localeCompare(b.script_name)));
        return true;
      } else {
        return false;
      }
    };

    getAllAgents();
  }, []);

  if (!agents) {
    return (
      <select onChange={() => null} value={'Loading...'}>
        <option value={'Loading...'}>Loading...</option>
      </select>
    );
  }

  return (
    <select onChange={handleChange} value={value}>
      <option value={''}>Select Agent...</option>
      {agents.map((agent) => (
        <option key={agent.id} value={agent.script_name}>
          {agent.script_name}
        </option>
      ))}
    </select>
  );
};
